import { ReactElement } from "react";
import { ReactComponent as FacebookIcon } from '@/images/facebook.svg';
import { ReactComponent as YoutubeIcon } from '@/images/youtube.svg';
import { ReactComponent as XIcon } from '@/images/X-Logo.svg';
import { ReactComponent as LinkedinIcon } from '@/images/linkedin.svg';
import { SocialNetworksContainer, SocialButtonLink } from './SocialNetworksLinksStyles';

export default function SocialNetworksLinks (): ReactElement
{
    return(
        <SocialNetworksContainer className="social-networks">
            <SocialButtonLink href="https://www.facebook.com/Ironia-Fintech-102982654720710" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FacebookIcon />
            </SocialButtonLink>
            <SocialButtonLink href="https://www.youtube.com/channel/UChJiXVzR0iwllShhaJTnTaw" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <YoutubeIcon />
            </SocialButtonLink>
            <SocialButtonLink href="https://x.com/IroniaTech" target="_blank" rel="noopener noreferrer" aria-label="X">
                <XIcon />
            </SocialButtonLink>
            <SocialButtonLink href="https://www.linkedin.com/company/ironia-fintech/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <LinkedinIcon />
            </SocialButtonLink>
        </SocialNetworksContainer>
    )
}